// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  padding: 1rem !important;
  background-color: #fff;
}

.login-row {
  width: 100%;
}
.form-row {
  width: 100%;
}

.signup-image {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.signup-h {
  color: #000;
  font-family: "Montserrat";
  font-size: var(--Font-Font-Size-h2, 1rem);
  font-style: normal;
  font-weight: 700;
  text-align: center;
  line-height: 30px;
}
.signup-sh {
  color: #666;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.signup-button {
  width: 100%;
  background-color: #d2042d;
  border: none;
  font-weight: 500;
  height: 50px;
}
.google-button-signup {
  background-color: #f5f5f5;
  border: none;
  width: 100%;
  height: 50px;
  margin-top: 1rem;
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}

.signup-container
  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
  background-color: #f5f5f5;
  border: none;
  width: 100%;
  height: 50px;
  margin-top: 1rem;
  color: rgb(12, 12, 12);
}
.google-button-signup:active {
  background-color: #f5f5f5 !important;
  color: rgb(12, 12, 12) !important;
  border: none !important;
}

.radio-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

.form-fields {
  width: 100%;
  display: flex;
}

.form-fields-css {
  gap: 2%;
  justify-content: space-between;
}

.login-text {
  text-align: center;
  margin-top: 5rem;
  color: #000;
  font-family: Roboto;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 600;
}

.login-text a {
  color: #d2042d;
  text-decoration: underline;
}
.signup-form {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-top: 2rem;
}
.signup-text {
  color: #000;
  font-family: Roboto;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 600;
  margin-top: 3rem;
}

.signup-text a {
  color: #d2042d;
  text-decoration: underline;
}
.ant-radio-wrapper:hover {
  border-color: #666;
}
.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
  border-color: #d2042d !important;
  background-color: #d2042d !important;
}

.opt-verification-input-container :hover {
  border-color: #000 !important;
  background-color: #ffffff !important;
}
.opt-verification-input-container {
  margin-top: 25px !important;
  margin-bottom: 25px !important;
}
.opt-verification-input-container .ant-input {
  width: 41px !important;
  height: 50px !important;
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000 !important;
}
.resend-text {
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px !important;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: var(--Colors-Primary-500, #d2042d);
  cursor: pointer;
}
.otp-expired{
  font-family: Roboto;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px !important;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: var(--Colors-Primary-500, #d2042d);
}
.change-mail-text .ant-typography {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  color: var(--Colors-Primary-500, #d2042d) !important;
  cursor: pointer;
}
@media (min-width: 769px) and (max-width: 2560px) {
  .signup-h {
    font-size: var(--Font-Font-Size-h3, 23px);
  }
  .sigup-form-container {
    width: 50%;
  }
  .signup-sh {
    margin-top: 1rem;
    font-size: var(--Font-Font-Size-p, 14px);
  }
}

@media (min-width: 0px) and (max-width: 768px) {
  .signup-h {
    font-size: var(--Font-Font-Size-h6, 19px);
    margin-top: 1rem;
  }
  .signup-sh {
    font-size: var(--Font-Font-Size-p, 12px);
  }
}

/* Media Queries for Responsiveness */
@media only screen and (max-width: 1024px) {
  .signup-form-container {
    background: #fff;
    padding: 15px 90px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-height: 100%;
    width: 100%;
  }
  .signup-container {
    padding: 0px;
    background-color: #fff;
  }
  .signup-h {
    color: #000;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    text-align: center;
    line-height: 30px;
  }
  .signup-sh {
    color: #666;
    text-align: center;

    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }
  .ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
    border-color: #d2042d !important;
    background-color: #d2042d !important;
  }
  .form-fields {
    display: flex;
    justify-content: flex-start;
    padding-left: 0px;
  }

  .ant-form-item .ant-form-item-explain-error {
    color: #ff4d4f;
  }

  .signup-button {
    width: 100%;
    background-color: #d2042d;
    border: none;
    font-weight: 500;
    height: 40px;
    margin-top: 20px !important;
  }
  .google-button-signup {
    width: 100%;
    background-color: #f5f5f5;
    border: none;
    color: rgb(12, 12, 12);
    height: 40px;
  }
  .signup-text {
    color: #000;
    font-family: Roboto;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 500;
    margin-top: 3rem;
  }

  .signup-text a {
    color: #d2042d;
    text-decoration: underline;
  }
}

/* Media Queries for Responsiveness */
@media only screen and (max-width: 768px) {
  .signup-container {
    padding: 10px;
    background-color: #fff;
  }

  .sigup-form-container {
    width: 100%;
  }
  .signup-h {
    color: #000;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    text-align: center;
    line-height: 30px;
  }
  .form-fields {
    display: flex;
  }
}

@media only screen and (max-width: 480px) {
  .signup-image {
    display: none;
  }
  .sigup-form-container {
    width: 100%;
  }
  .form-fields {
    padding-left: 25px !important;
  }
  .radio-grp-btn {
    padding-left: 5px !important;
  }
  .signup-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 40px 0px 0px 0px;
    width: 100%;
  }
  .signup-h {
    color: #000;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    text-align: center;
    line-height: 30px;
  }
  .form-fields {
    display: flex;
    padding-left: 0px !important;
  }
  .signup-button
    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: #f5f5f5;
    border: none;
    width: 100%;
    height: 50px;
    margin-top: 1rem;
    color: rgb(12, 12, 12);
  }
  .ant-form-item .ant-form-item-explain-error {
    color: #ff4d4f;
  }
}
@media only screen and (max-width: 380px) {
  .signup-image {
    display: none;
  }
  .sigup-form-container {
    margin-top: 0px;
    padding: 0% 0%;
    width: 100%;
  }
  .signup-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: #fff;
    padding: 10px 0px 10px 0px;
    width: auto;
    margin-top: 0%;
  }
  .signup-form-container {
    background: #fff;
    padding: 0px 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    min-height: 100%;
    width: 100%;
  }
  .signup-h {
    color: #000;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    text-align: center;
    line-height: 30px;
  }
  .form-fields {
    display: flex;

    padding-left: 1px !important;
  }
  .radio-grp-btn {
    padding-left: 5px;
  }
  .signup-button
    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: #f5f5f5;
    border: none;
    width: 100%;
    height: 50px;
    margin-top: 1rem;
    color: rgb(12, 12, 12);
  }

  .ant-form-item .ant-form-item-explain-error {
    color: #ff4d4f;
  }
  .signup-button {
    width: 95%;
    background-color: #d2042d;
    border: none;
    font-weight: 500;
    height: 40px;
  }
  .google-button-signup {
    width: 95%;
    background-color: #f5f5f5;
    border: none;
    color: rgb(12, 12, 12);
    height: 40px;
  }
}

@media only screen and (max-width: 320px) {
  .signup-image {
    display: none;
  }
  .sigup-form-container {
    margin-top: 0px;
    padding: 0% 0%;
    width: 100%;
  }
  .signup-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: #fff;
    padding: 10px 0px 10px 0px;
    width: auto;
    margin-top: 0%;
  }
  .signup-form-container {
    background: #fff;
    padding: 0px 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    min-height: 100%;
    width: 100%;
  }

  .signup-h {
    color: #000;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    text-align: center;
    line-height: 30px;
  }
  .signup-sh {
    color: #666;
    text-align: center;
    font-family: Roboto;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
  .signup-text {
    color: #000;
    font-family: Roboto;
    font-size: 0.8rem;
    font-style: normal;
    font-weight: 400;
    margin-top: 2rem;
  }
  .floating-input {
    width: 6rem !important;
  }
  .floating-input-container-middle {
    width: 19rem !important;
  }
  .radio-grp-btn {
    padding-left: 1rem !important;
  }
  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: #f5f5f5;
    border: none;
    width: 100%;
    height: 50px;
    margin-top: 1rem;
    color: rgb(12, 12, 12);
  }
  .form-fields {
    display: flex;
    padding-left: 0px !important;
  }
  .ant-form-item .ant-form-item-explain-error {
    color: #ff4d4f;
  }
  .signup-button {
    width: 90%;
    background-color: #d2042d;
    border: none;
    font-weight: 500;
    height: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/Signup/SignupPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,OAAO;EACP,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,oDAAoD;EACpD,eAAe;AACjB;AACA;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,UAAU;EACZ;EACA;IACE,gBAAgB;IAChB,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,gBAAgB;EAClB;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;;IAElB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,gCAAgC;IAChC,oCAAoC;EACtC;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;EACb;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,WAAW;EACb;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,4BAA4B;EAC9B;EACA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;IAC1B,WAAW;IACX,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;IACxC,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,aAAa;;IAEb,4BAA4B;EAC9B;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,cAAc;IACd,WAAW;EACb;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;IAC1B,WAAW;IACX,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;IACxC,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,4BAA4B;EAC9B;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,YAAY;EACd;AACF","sourcesContent":[".signup-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  height: 100%;\n  padding: 1rem !important;\n  background-color: #fff;\n}\n\n.login-row {\n  width: 100%;\n}\n.form-row {\n  width: 100%;\n}\n\n.signup-image {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\n.signup-h {\n  color: #000;\n  font-family: \"Montserrat\";\n  font-size: var(--Font-Font-Size-h2, 1rem);\n  font-style: normal;\n  font-weight: 700;\n  text-align: center;\n  line-height: 30px;\n}\n.signup-sh {\n  color: #666;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 14px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n.signup-button {\n  width: 100%;\n  background-color: #d2042d;\n  border: none;\n  font-weight: 500;\n  height: 50px;\n}\n.google-button-signup {\n  background-color: #f5f5f5;\n  border: none;\n  width: 100%;\n  height: 50px;\n  margin-top: 1rem;\n  color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n}\n\n.signup-container\n  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n  background-color: #f5f5f5;\n  border: none;\n  width: 100%;\n  height: 50px;\n  margin-top: 1rem;\n  color: rgb(12, 12, 12);\n}\n.google-button-signup:active {\n  background-color: #f5f5f5 !important;\n  color: rgb(12, 12, 12) !important;\n  border: none !important;\n}\n\n.radio-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n.form-fields {\n  width: 100%;\n  display: flex;\n}\n\n.form-fields-css {\n  gap: 2%;\n  justify-content: space-between;\n}\n\n.login-text {\n  text-align: center;\n  margin-top: 5rem;\n  color: #000;\n  font-family: Roboto;\n  font-size: 0.9rem;\n  font-style: normal;\n  font-weight: 600;\n}\n\n.login-text a {\n  color: #d2042d;\n  text-decoration: underline;\n}\n.signup-form {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  padding-top: 2rem;\n}\n.signup-text {\n  color: #000;\n  font-family: Roboto;\n  font-size: 0.9rem;\n  font-style: normal;\n  font-weight: 600;\n  margin-top: 3rem;\n}\n\n.signup-text a {\n  color: #d2042d;\n  text-decoration: underline;\n}\n.ant-radio-wrapper:hover {\n  border-color: #666;\n}\n.ant-radio-wrapper .ant-radio-checked .ant-radio-inner {\n  border-color: #d2042d !important;\n  background-color: #d2042d !important;\n}\n\n.opt-verification-input-container :hover {\n  border-color: #000 !important;\n  background-color: #ffffff !important;\n}\n.opt-verification-input-container {\n  margin-top: 25px !important;\n  margin-bottom: 25px !important;\n}\n.opt-verification-input-container .ant-input {\n  width: 41px !important;\n  height: 50px !important;\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #000 !important;\n}\n.resend-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px !important;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: var(--Colors-Primary-500, #d2042d);\n  cursor: pointer;\n}\n.otp-expired{\n  font-family: Roboto;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 16px !important;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n.change-mail-text .ant-typography {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  color: var(--Colors-Primary-500, #d2042d) !important;\n  cursor: pointer;\n}\n@media (min-width: 769px) and (max-width: 2560px) {\n  .signup-h {\n    font-size: var(--Font-Font-Size-h3, 23px);\n  }\n  .sigup-form-container {\n    width: 50%;\n  }\n  .signup-sh {\n    margin-top: 1rem;\n    font-size: var(--Font-Font-Size-p, 14px);\n  }\n}\n\n@media (min-width: 0px) and (max-width: 768px) {\n  .signup-h {\n    font-size: var(--Font-Font-Size-h6, 19px);\n    margin-top: 1rem;\n  }\n  .signup-sh {\n    font-size: var(--Font-Font-Size-p, 12px);\n  }\n}\n\n/* Media Queries for Responsiveness */\n@media only screen and (max-width: 1024px) {\n  .signup-form-container {\n    background: #fff;\n    padding: 15px 90px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    max-height: 100%;\n    width: 100%;\n  }\n  .signup-container {\n    padding: 0px;\n    background-color: #fff;\n  }\n  .signup-h {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-style: normal;\n    font-weight: 700;\n    text-align: center;\n    line-height: 30px;\n  }\n  .signup-sh {\n    color: #666;\n    text-align: center;\n\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n  }\n  .ant-radio-wrapper .ant-radio-checked .ant-radio-inner {\n    border-color: #d2042d !important;\n    background-color: #d2042d !important;\n  }\n  .form-fields {\n    display: flex;\n    justify-content: flex-start;\n    padding-left: 0px;\n  }\n\n  .ant-form-item .ant-form-item-explain-error {\n    color: #ff4d4f;\n  }\n\n  .signup-button {\n    width: 100%;\n    background-color: #d2042d;\n    border: none;\n    font-weight: 500;\n    height: 40px;\n    margin-top: 20px !important;\n  }\n  .google-button-signup {\n    width: 100%;\n    background-color: #f5f5f5;\n    border: none;\n    color: rgb(12, 12, 12);\n    height: 40px;\n  }\n  .signup-text {\n    color: #000;\n    font-family: Roboto;\n    font-size: 0.9rem;\n    font-style: normal;\n    font-weight: 500;\n    margin-top: 3rem;\n  }\n\n  .signup-text a {\n    color: #d2042d;\n    text-decoration: underline;\n  }\n}\n\n/* Media Queries for Responsiveness */\n@media only screen and (max-width: 768px) {\n  .signup-container {\n    padding: 10px;\n    background-color: #fff;\n  }\n\n  .sigup-form-container {\n    width: 100%;\n  }\n  .signup-h {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-style: normal;\n    font-weight: 700;\n    text-align: center;\n    line-height: 30px;\n  }\n  .form-fields {\n    display: flex;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .signup-image {\n    display: none;\n  }\n  .sigup-form-container {\n    width: 100%;\n  }\n  .form-fields {\n    padding-left: 25px !important;\n  }\n  .radio-grp-btn {\n    padding-left: 5px !important;\n  }\n  .signup-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    padding: 40px 0px 0px 0px;\n    width: 100%;\n  }\n  .signup-h {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-style: normal;\n    font-weight: 700;\n    text-align: center;\n    line-height: 30px;\n  }\n  .form-fields {\n    display: flex;\n    padding-left: 0px !important;\n  }\n  .signup-button\n    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: #f5f5f5;\n    border: none;\n    width: 100%;\n    height: 50px;\n    margin-top: 1rem;\n    color: rgb(12, 12, 12);\n  }\n  .ant-form-item .ant-form-item-explain-error {\n    color: #ff4d4f;\n  }\n}\n@media only screen and (max-width: 380px) {\n  .signup-image {\n    display: none;\n  }\n  .sigup-form-container {\n    margin-top: 0px;\n    padding: 0% 0%;\n    width: 100%;\n  }\n  .signup-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    background-color: #fff;\n    padding: 10px 0px 10px 0px;\n    width: auto;\n    margin-top: 0%;\n  }\n  .signup-form-container {\n    background: #fff;\n    padding: 0px 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    min-height: 100%;\n    width: 100%;\n  }\n  .signup-h {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-style: normal;\n    font-weight: 700;\n    text-align: center;\n    line-height: 30px;\n  }\n  .form-fields {\n    display: flex;\n\n    padding-left: 1px !important;\n  }\n  .radio-grp-btn {\n    padding-left: 5px;\n  }\n  .signup-button\n    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: #f5f5f5;\n    border: none;\n    width: 100%;\n    height: 50px;\n    margin-top: 1rem;\n    color: rgb(12, 12, 12);\n  }\n\n  .ant-form-item .ant-form-item-explain-error {\n    color: #ff4d4f;\n  }\n  .signup-button {\n    width: 95%;\n    background-color: #d2042d;\n    border: none;\n    font-weight: 500;\n    height: 40px;\n  }\n  .google-button-signup {\n    width: 95%;\n    background-color: #f5f5f5;\n    border: none;\n    color: rgb(12, 12, 12);\n    height: 40px;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  .signup-image {\n    display: none;\n  }\n  .sigup-form-container {\n    margin-top: 0px;\n    padding: 0% 0%;\n    width: 100%;\n  }\n  .signup-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    background-color: #fff;\n    padding: 10px 0px 10px 0px;\n    width: auto;\n    margin-top: 0%;\n  }\n  .signup-form-container {\n    background: #fff;\n    padding: 0px 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    min-height: 100%;\n    width: 100%;\n  }\n\n  .signup-h {\n    color: #000;\n    font-family: \"Montserrat\";\n    font-style: normal;\n    font-weight: 700;\n    text-align: center;\n    line-height: 30px;\n  }\n  .signup-sh {\n    color: #666;\n    text-align: center;\n    font-family: Roboto;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n  .signup-text {\n    color: #000;\n    font-family: Roboto;\n    font-size: 0.8rem;\n    font-style: normal;\n    font-weight: 400;\n    margin-top: 2rem;\n  }\n  .floating-input {\n    width: 6rem !important;\n  }\n  .floating-input-container-middle {\n    width: 19rem !important;\n  }\n  .radio-grp-btn {\n    padding-left: 1rem !important;\n  }\n  .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: #f5f5f5;\n    border: none;\n    width: 100%;\n    height: 50px;\n    margin-top: 1rem;\n    color: rgb(12, 12, 12);\n  }\n  .form-fields {\n    display: flex;\n    padding-left: 0px !important;\n  }\n  .ant-form-item .ant-form-item-explain-error {\n    color: #ff4d4f;\n  }\n  .signup-button {\n    width: 90%;\n    background-color: #d2042d;\n    border: none;\n    font-weight: 500;\n    height: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
